import React, { useState, useMemo } from 'react';

export default function NewsletterArchive({ list }) {
  const [open, setOpen] = useState(false);
  const grouped = useMemo(() => groupByYearAndMonth(list, 'send_time'), [list]);
  const years = grouped ? Object.keys(grouped).sort().reverse() : [];

  return (
    <div className="newsletter-archive col-lg-6 offset-lg-4 my-5 py-4">
      <h3 className="mb-3">Newsletter archive</h3>
      {years.map(
        (year, i) =>
          (open || i < 2) && (
            <div key={i}>
              <h5 className="my-4">{year}</h5>
              {Object.keys(grouped[year]).map((month) =>
                grouped[year][month].map(({ id, long_archive_url, title }) => (
                  <ul key={id} className="list-unstyled">
                    <li>
                      <a href={long_archive_url} target="_blank">
                        {title}
                      </a>
                    </li>
                  </ul>
                ))
              )}
            </div>
          )
      )}
      {!open && years.length > 2 && (
        <div className="my-4">
          <button
            className="btn btn-outline-primary"
            onClick={() => setOpen(true)}>
            Show all
          </button>
        </div>
      )}
    </div>
  );
}

function groupByYearAndMonth(list, key) {
  return list.reduce((r, item) => {
    const date = new Date(item[key]);
    const year = date.getFullYear();
    const month = date.getMonth();
    const title = `${date.toLocaleString('en', { month: 'long' })} newsletter`;
    r[year] ||= {};
    r[year][month] ||= [];
    r[year][month].push({ title, ...item });
    return r;
  }, {});
}
